import React from "react";
import UserTable from "./UserTable";
import UserModals from "./UserModals";
import UserHeader from "./UserHeader";

const Index = ({ 
  arg: {
    users,
    filteredUsers,
    loading,
    searchData,
    setSearchData,
    handleSearchInput,
    pageC,
    setPageC,
    limit,
    setLimit,
    totalUsers,
    roles,
    selectedUser,
    setSelectedUser,
    isCreateModalVisible,
    setIsCreateModalVisible,
    isEditModalVisible,
    setIsEditModalVisible,
    isViewModalVisible,
    setIsViewModalVisible,
    isDeleteModalVisible,
    setIsDeleteModalVisible,
    is2FAModalVisible,
    setIs2FAModalVisible,
    createForm,
    editForm,
    handleCreateUser,
    handleUpdateUser,
    handleDeleteUser,
    handleToggle2FA,
    handleGenerateBackupCodes,
    handleUserDetailsClick,
    fetchUsers,
    handleRefresh,
    handleExportData,
    handleSuspendUser
  }
}) => {
  return (
    <div className="contentclss">
      <UserHeader 
        searchData={searchData}
        setSearchData={setSearchData}
        handleSearchInput={handleSearchInput}
        loading={loading}
        handleRefresh={handleRefresh}
        setIsCreateModalVisible={setIsCreateModalVisible}
        handleExportData={handleExportData}
      />
      
      <div className="sub2container">
        <UserTable
          filteredUsers={filteredUsers}
          loading={loading}
          pageC={pageC}
          setPageC={setPageC}
          limit={limit}
          setLimit={setLimit}
          totalUsers={totalUsers}
          setSelectedUser={setSelectedUser}
          setIsEditModalVisible={setIsEditModalVisible}
          setIsViewModalVisible={setIsViewModalVisible}
          setIs2FAModalVisible={setIs2FAModalVisible}
          setIsDeleteModalVisible={setIsDeleteModalVisible}
          handleUserDetailsClick={handleUserDetailsClick}
          editForm={editForm}
          handleSuspendUser={handleSuspendUser}
        />
      </div>

      <UserModals
        roles={roles}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        isCreateModalVisible={isCreateModalVisible}
        setIsCreateModalVisible={setIsCreateModalVisible}
        isEditModalVisible={isEditModalVisible}
        setIsEditModalVisible={setIsEditModalVisible}
        isViewModalVisible={isViewModalVisible}
        setIsViewModalVisible={setIsViewModalVisible}
        isDeleteModalVisible={isDeleteModalVisible}
        setIsDeleteModalVisible={setIsDeleteModalVisible}
        is2FAModalVisible={is2FAModalVisible}
        setIs2FAModalVisible={setIs2FAModalVisible}
        createForm={createForm}
        editForm={editForm}
        handleCreateUser={handleCreateUser}
        handleUpdateUser={handleUpdateUser}
        handleDeleteUser={handleDeleteUser}
        handleToggle2FA={handleToggle2FA}
        handleGenerateBackupCodes={handleGenerateBackupCodes}
      />
    </div>
  );
};

export default Index;
